import { SelectInputV3, TextInputV3 } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

import FormContainer from './index'

export const StyledFormContainer = styled(FormContainer)`
  &&& {
    width: 100%;
    max-width: 400px;
    padding-left: 30px;
    padding-right: 30px;

    @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
      max-width: unset;
      padding-left: unset;
      padding-right: unset;
    }
  }
`

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 0;
  }
`

export const FormItem = styled.div<{ toTheLeft?: boolean }>`
  flex-basis: 50%;
  width: 100%;

  &:not(:last-child) {
    padding-bottom: 20px;
  }

  & > div.us-citizen-checkbox {
    padding-bottom: 0

    & > span:first-child {
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    flex-basis: 100%;
  }

  ${props => props.toTheLeft && 'margin-right: auto;'}
`

export const StyledTextInput = styled(TextInputV3)`
  width: 100%;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    & > div > div,
    input {
      width: 100%;
      justify-content: unset;
    }
  }
`

export const StyledSelect = styled(SelectInputV3)`
  @media screen and (max-width: ${props => props.theme.breakpoints.sm}px) {
    width: 100%;
  }
`
